import axios from 'axios';
import { apiEndpoint } from '../config';
// ----------------------------------------------------------------------

console.log('API ENDPOINT');

const axiosInstance = axios.create({
  baseURL: apiEndpoint
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject((error.response && error.response.data) || 'Something went wrong')
);

export default axiosInstance;
